import { useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';

import { Popover, Select } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import { NHAN_VAI_TRO } from '../../constants';
import { useThemNguoiThamGia } from '../../hooks/useNhiemVu';
import { thanhNguoiThamGia, VAI_TRO_THAM_GIA } from '../../nghiep-vu/nhiem-vu';
import type { DonViDanhBa, NutNhiemVu, VaiTroThamGia } from '../../types-nhiem-vu';
import { UserSearchSelect } from './UserSearchSelect';

/** Thêm một người ngay tại dòng, không phải mở cả form sửa. */
export function QuickAddParticipant({ task, orgs }: { task: NutNhiemVu; orgs: DonViDanhBa[] }) {
  const { t } = useT();
  const [open, setOpen] = useState(false);
  const coChuTri = task.participants.some((p) => p.role === 'CHU_TRI');
  const [role, setRole] = useState<VaiTroThamGia>(coChuTri ? 'PHOI_HOP' : 'CHU_TRI');
  const add = useThemNguoiThamGia();

  const content = (
    <div className="w-72 space-y-2" onClick={(e) => e.stopPropagation()}>
      <Select<VaiTroThamGia>
        aria-label={t('vanBanNhiemVu.themNhanh.vaiTro')}
        className="w-full"
        value={role}
        onChange={setRole}
        options={VAI_TRO_THAM_GIA.map((r) => ({ value: r, label: t(NHAN_VAI_TRO[r]) }))}
      />
      {open && (
        <UserSearchSelect
          autoFocus
          excludeIds={task.participants.map((p) => p.user_id)}
          onPick={(user) =>
            add.mutate({ nv: task, nguoi: thanhNguoiThamGia(user, orgs, role) }, { onSuccess: () => setOpen(false) })
          }
        />
      )}
    </div>
  );

  return (
    <Popover
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      title={t('vanBanNhiemVu.themNhanh.tieuDe')}
      content={content}
      placement="bottomLeft"
    >
      <button
        type="button"
        aria-label={t('vanBanNhiemVu.ds.themNguoiThucHien')}
        title={t('vanBanNhiemVu.ds.themNguoiThucHien')}
        disabled={add.isPending}
        onClick={(e) => e.stopPropagation()}
        className="ml-1.5 flex h-6 w-6 items-center justify-center rounded-full border border-dashed border-strong text-xs text-content-muted hover:border-primary-500 hover:text-primary-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-500 disabled:opacity-50"
      >
        <PlusOutlined />
      </button>
    </Popover>
  );
}
